import React, { memo } from 'react';
import { splitIntoChunks } from 'app/components/swipeableViews/splitArrayIntoChunks';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import MatchesView from 'app/components/competitionModule/matches/MatchesView';
const MATCHES_PER_VIEW = 8;
function SwipeableCompetitionModuleMatches(_ref) {
  let {
    competitionSlug,
    matches
  } = _ref;
  const splitMatches = splitIntoChunks(matches, MATCHES_PER_VIEW);
  const renderView = _ref2 => {
    let {
      index
    } = _ref2;
    return /*#__PURE__*/React.createElement(MatchesView, {
      key: "".concat(competitionSlug, "-matches-view-").concat(index),
      matches: splitMatches[index],
      "data-sentry-element": "MatchesView",
      "data-sentry-component": "renderView",
      "data-sentry-source-file": "SwipeableCompetitionModuleMatches.tsx"
    });
  };
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    stepCount: splitMatches.length,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "SwipeableCompetitionModuleMatches",
    "data-sentry-source-file": "SwipeableCompetitionModuleMatches.tsx"
  });
}
export default /*#__PURE__*/memo(SwipeableCompetitionModuleMatches);